export const enum VerifyAccountForResetPasswordType {
  username = 0,
  phone = 1,
  email = 2,
}
